import { useNavigate, useParams } from 'react-router-dom'
import { Typography, Button, CircularProgress } from '@mui/material'
import {
  KeyboardBackspace,
  CameraAlt,
  FlipCameraIos,
} from '@mui/icons-material'
import { LoadingButton } from 'components/mui'
import classNames from 'classnames'

import useCaptureCamera from 'views/DigitalTrayMapping/CaptureTray/CaptureCamera/CaptureCamera.logic'

import './CaptureTrayReference.scss'
import SubmitImageDialog from 'views/DigitalTrayMapping/CaptureTray/CaptureCamera/SubmitImageDialog/SubmitImageDialog'

const CaptureTrayReference = () => {
  const { trayId, subTrayItemId } = useParams()
  const navigate = useNavigate()

  const {
    videoRef,
    mediaStream,
    videoHeight,
    orientation,
    isCameraMenuOpen,
    cameras,
    activeCamera,
    handleSelectCamera,
    handleToggleCameraMenu,
    handleUsageCaptureImage,
    image,
    setImage,
    isSubmitModalOpen,
    handleSubmitModalClose,
  } = useCaptureCamera()

  const handleGoBack = () => {
    navigate(`/tray-management/${trayId}/${subTrayItemId}`)
  }

  const handleCaptureImage = () => {
    handleUsageCaptureImage()
  }

  if (videoRef === null || mediaStream === null) {
    return (
      <div className="capture-tray-reference_page">
        <div className="capture-header">
          <Button
            className="back_button"
            onClick={handleGoBack}
            startIcon={<KeyboardBackspace />}
          >
            Back
          </Button>

          <div className="header-content">
            <Typography variant="h5" className="title">
              Capture Reference Image
            </Typography>
            <Typography variant="body1" className="instructions">
              Loading camera...
            </Typography>
          </div>
        </div>
        <div className="loading-container">
          <CircularProgress />
        </div>
      </div>
    )
  }

  return (
    <div className="capture-tray-reference_page">
      <div className="capture-header">
        <Button
          className="back_button"
          onClick={handleGoBack}
          startIcon={<KeyboardBackspace />}
        >
          Back
        </Button>
      </div>

      <div className="camera-container" style={{ height: videoHeight }}>
        <video
          className="camera-feed"
          ref={videoRef}
          autoPlay
          muted
          playsInline
        />

        <div
          className="buttons-container"
          style={{
            height: videoHeight,
            justifyContent: orientation === 'landscape' ? 'center' : 'flex-end',
          }}
        >
          <div className="camera-options_container">
            <LoadingButton
              variant="contained"
              loading={false}
              onClick={handleToggleCameraMenu}
              startIcon={<FlipCameraIos />}
              className="camera-switch"
            >
              Switch Camera
            </LoadingButton>

            {isCameraMenuOpen && (
              <div className="camera-options">
                {cameras.map((camera: any) => (
                  <div
                    key={camera.deviceId}
                    className={classNames('camera-option', {
                      active: camera.deviceId === activeCamera?.deviceId,
                    })}
                    onClick={() => handleSelectCamera(camera)}
                  >
                    <Typography className="label">{camera.label}</Typography>
                    <Typography className="type">
                      {camera?.cameraType}
                    </Typography>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="capture-guidance">
            <Typography variant="body2" className="guidance-text">
              Center the tray in frame and ensure good lighting
            </Typography>
          </div>

          <div className="capture-buttons">
            <LoadingButton
              className="capture"
              onClick={handleCaptureImage}
              loading={false}
              variant="text"
            >
              <CameraAlt className="icon" />
            </LoadingButton>
          </div>
        </div>
      </div>

      <SubmitImageDialog
        open={isSubmitModalOpen}
        trayImage={image}
        setTrayImage={setImage}
        handleClose={handleSubmitModalClose}
      />
    </div>
  )
}

export default CaptureTrayReference
